<template>
  <div>
    <div class="form-group">
      <label> {{ __("forms.documentsTemplate.signature_level") }} </label>
      <select class="form-control" name="documentsTemplate[signature_level]" required
              v-model="documentTemplateParams.signature_level">

        <option value="no_signature_required">{{ __("forms.documentsTemplate.no_signature_required") }}</option>
        <option value="electronic_signature">{{ __("forms.documentsTemplate.basic_electronic_signature") }}</option>
        <option value="advanced_electronic_signature">
          {{ __("forms.documentsTemplate.advanced_electronic_signature") }}
        </option>
      </select>
    </div>

    <div class="form-group" v-if="documentTemplateParams.signature_level == 'electronic_signature'">

      <label> {{ __("forms.documentsTemplate.signature_authentication_mode") }} </label>
      <select class="form-control" name="documentsTemplate[signature_authentication_mode]" required
              v-model="documentTemplateParams.signature_authentication_mode">
        <option value="no_otp">{{ __('forms.documentsTemplate.no_otp') }}</option>
        <option value="otp_email">{{ __('forms.documentsTemplate.otp_email') }}</option>
        <option value="otp_sms">{{ __('forms.documentsTemplate.otp_sms') }}</option>
      </select>
    </div>
    <div class="form-group" v-else-if="documentTemplateParams.signature_level == 'advanced_electronic_signature'">
      <label> {{ __("forms.documentsTemplate.signature_authentication_mode") }} </label>
      <h3>{{ __('forms.documentsTemplate.otp_sms') }}</h3>
      <input type="hidden" name="documentsTemplate[signature_authentication_mode]" value="otp_email">
    </div>
    <div class="form-group" v-else >
      <!-- Must be set, but it will never use -->
      <input type="hidden" name="documentsTemplate[signature_authentication_mode]" value="otp_email"></input>
    </div>

  </div>
</template>

<script>
export default {
  props:
      {
        document_template: {
          type: Object,
          required: true,
        },
      },
  mounted() {
    this.documentTemplateParams = this.document_template;    
  },
  data() {
    return {
      documentTemplateParams: {},
    };
  },
  methods: {},
};
</script>
